import React from "react";

import { MapPinIcon } from "@heroicons/react/20/solid";
import { useDispatch } from "react-redux";
import { TwListMoreButton, TwMoreOptions } from "../../components/tailwind";
import { useLocalStorage } from "../../hooks";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForServices } from "../../utils/confighelpers";

export default function LocationTile({
  popover,
  setLoading,
  handleSessionClick,
  reload,
  item,
}) {
  const dispatch = useDispatch();
  const [userToken] = useLocalStorage("userToken");

  const deleteLocations = async (id) => {
    const manageClassesConfig = {
      method: "delete",
      url: `${getUrlForServices()}venue/${id}`,
    };
    dispatch(setGlobalLoading(true));
    const responce = await axiosInstance(manageClassesConfig);
    dispatch(setGlobalLoading(false));
    if (responce.status === 200) {
    }
    reload();
    setLoading(false)
  };

  return (<li className="flex items-center justify-between gap-x-6 p-5 rounded-xl hover:bg-list-hover border border-bright-gray">
    <div className="flex min-w-0 gap-x-4">
      <div className="size-12 min-w-12 flex justify-center items-center bg-brown-coffee rounded-xl object-fill"><MapPinIcon className="size-7 fill-white" /></div>
      <div className="min-w-0 flex-auto">
        <p className="truncate text-sm/6 font-semibold text-gray-900">{item?.addressName || item.address}</p>
        <p className="mt-1 truncate text-xs/5 text-gray-500">{item.address}</p>
      </div>
    </div>
    <div className="flex flex-none items-center gap-x-4">
      <TwMoreOptions
        options={[
          <TwListMoreButton
            className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
            onClick={() => {
              handleSessionClick();
            }}
          >
            Edit
          </TwListMoreButton>,
          // <TwListMoreButton
          //   className="block px-3 py-1 text-sm/6 text-gray-900 data-[focus]:bg-gray-50 data-[focus]:outline-none"
          //   onClick={() => {
          //     // deleteLocations(item._id);
          //   }}
          // >
          //   Delete
          // </TwListMoreButton>
        ]} />
    </div>
  </li>);
}
